<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="w-full rounded-3xl bg-red-100 overflow-hidden shadow-md h-auto"
        >
          <div class="w-full p-3 bg-red-100">
            <span @click="$router.back()" class="cursor-pointer">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
              Kontraktor : <b>{{ detailSupplier.namaKontraktor }}</b>
            </span>
          </div>
          <div class="p-7 bg-white rounded-t-3xl">
            <div class="row mb-5">
              <div class="col-md-12">
                <div class="d-flex">
                  <div class="pr-2" style="margin-right: 1rem">
                    <img :src="url_icon" style="width: 3rem" />
                  </div>
                  <div class="row w-100">
                    <div class="col-md-6">
                      <p
                        class="mb-1"
                        style="
                          font-size: 2rem;
                          line-height: 1.5rem;
                          font-family: 'Inter-Bold';
                        "
                      >
                        {{ detailSupplier.namaKontraktor }}
                      </p>
                      <div style="font-size: 1rem">
                        Nilai Prakualifikasi :
                        {{
                          detailSupplier.nilaiPraKplh
                            ? detailSupplier.nilaiPraKplh
                            : "-"
                        }}
                        | Predikat PJP :
                        <span
                          v-if="detailSupplier.predikat == 'HIJAU'"
                          class="text-success"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-square"
                            style=""
                          />
                          {{
                            detailSupplier.nilaiPredikat != null
                              ? detailSupplier.nilaiPredikat
                              : "-"
                          }}
                        </span>
                        <span
                          v-else-if="detailSupplier.predikat == 'EMAS'"
                          style="color: #e19140"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-square"
                            style=""
                          />
                          {{
                            detailSupplier.nilaiPredikat != null
                              ? detailSupplier.nilaiPredikat
                              : "-"
                          }}
                        </span>
                        <span
                          v-else-if="detailSupplier.predikat == 'BIRU'"
                          style="color: #326bd5"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-square"
                            style=""
                          />
                          {{
                            detailSupplier.nilaiPredikat != null
                              ? detailSupplier.nilaiPredikat
                              : "-"
                          }}
                        </span>
                        <span
                          v-else-if="detailSupplier.predikat == 'HITAM'"
                          style="color: #171716"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-square"
                            style=""
                          />
                          {{
                            detailSupplier.nilaiPredikat != null
                              ? detailSupplier.nilaiPredikat
                              : "-"
                          }}
                        </span>
                        <span
                          v-else-if="detailSupplier.predikat == 'MERAH'"
                          class="text-danger"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-square"
                            style=""
                          />
                          {{
                            detailSupplier.nilaiPredikat != null
                              ? detailSupplier.nilaiPredikat
                              : "-"
                          }}
                        </span>
                        <span v-else> - </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col-md-9">
                <p
                  class="mb-1"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  INFORMASI UMUM
                </p>
                <div class="d-flex mb-1">
                  <p
                    class="me-5"
                    style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                  >
                    Inisial : {{ detailSupplier.inisial }}
                  </p>
                  <p
                    class="me-5"
                    style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                  >
                    Klasifikasi : {{ detailSupplier.jenis }}
                  </p>
                  <p
                    class="me-5"
                    style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-location-dot"
                      style=""
                    />
                    {{
                      detailSupplier.wilayah == null
                        ? "-"
                        : detailSupplier.wilayah
                    }}
                  </p>
                  <p
                    class="me-5"
                    style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                  >
                    Kualifikasi Usaha :
                    {{
                      detailSupplier.kualifikasiUsaha == 1
                        ? "Kecil"
                        : detailSupplier.kualifikasiUsaha == 2
                        ? "Sedang"
                        : detailSupplier.kualifikasiUsaha == 3
                        ? "Besar"
                        : "-"
                    }}
                  </p>
                </div>
                <!-- <hr class="hr" /> -->
                <p
                  class="mb-1"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  IZIN LEGALITAS
                </p>
                <div class="d-flex mb-2">
                  <table class="table table-borderless">
                    <tbody
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      <tr>
                        <td width="15%">No. NIB</td>
                        <td width="1%">:</td>
                        <td width="25%">
                          {{
                            detailSupplier.noNib == null ||
                            detailSupplier.noNib == ""
                              ? "-"
                              : detailSupplier.noNib
                          }}
                        </td>
                        <td>
                          <i
                            v-if="detailSupplier.fileNib == null"
                            class="text-danger"
                            >Belum ada dokumen NIB</i
                          >
                          <a
                            v-else
                            @click="viewFile(detailSupplier.fileNib)"
                            class="text-danger pointer"
                          >
                            <font-awesome-icon
                              style="color: #dd3737; cursor: pointer"
                              icon="fa-solid fa-eye"
                            />
                            Dokumen NIB
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>No. IUJP</td>
                        <td>:</td>
                        <td>
                          {{
                            detailSupplier.noIujp == null ||
                            detailSupplier.noIujp == ""
                              ? "-"
                              : detailSupplier.noIujp
                          }}
                        </td>
                        <td>
                          <i
                            v-if="detailSupplier.fileIujp == null"
                            class="text-danger"
                            >Belum ada dokumen IUJP</i
                          >
                          <a
                            v-else
                            @click="viewFile(detailSupplier.fileIujp)"
                            class="text-danger pointer"
                          >
                            <font-awesome-icon
                              style="color: #dd3737; cursor: pointer"
                              icon="fa-solid fa-eye"
                            />
                            Dokumen IUJP
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>Masa Berlaku</td>
                        <td>:</td>
                        <td>
                          {{
                            detailSupplier.tglExpIujp == null
                              ? "-"
                              : moment(detailSupplier.tglExpIujp).format(
                                  "DD MMMM YYYY"
                                )
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-md-3">
                <div
                  class="rounded w-100 p-3"
                  style="min-height: 10vh; background-color: #fff1f1"
                >
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    INFORMASI PJO
                  </p>
                  <p
                    class="mb-1 fw-bold pt-3"
                    style="font-family: 'Inter-Bold'; font-size: 1rem"
                  >
                    {{ detailSupplier.namaPjo ? detailSupplier.namaPjo : "-" }}
                  </p>
                  <div class="d-flex align-items-center pt-2 fs-8">
                    <svg
                      width="14"
                      height="11"
                      viewBox="0 0 14 11"
                      fill="none"
                      style="margin-right: 0.3rem"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.66536 10.6665H0.332031C0.332031 8.45737 2.12289 6.6665 4.33203 6.6665C6.54117 6.6665 8.33203 8.45737 8.33203 10.6665H6.9987C6.9987 9.19374 5.80479 7.99984 4.33203 7.99984C2.85927 7.99984 1.66536 9.19374 1.66536 10.6665ZM9.66137 8.27317L7.85736 6.47317L8.7987 5.52784L9.66003 6.38917L12.5267 3.52784L13.468 4.47184L9.66003 8.27184L9.66137 8.27317ZM4.33203 5.99984C2.85927 5.99984 1.66536 4.80593 1.66536 3.33317C1.66536 1.86041 2.85927 0.666504 4.33203 0.666504C5.80479 0.666504 6.9987 1.86041 6.9987 3.33317C6.99686 4.80517 5.80403 5.998 4.33203 5.99984ZM4.33203 1.99984C3.60363 2.00058 3.01062 2.58574 3.00019 3.31406C2.98975 4.04239 3.56574 4.64431 4.29382 4.66592C5.02191 4.68753 5.63259 4.12084 5.66536 3.39317V3.65984V3.33317C5.66536 2.59679 5.06841 1.99984 4.33203 1.99984Z"
                        fill="#B51A1A"
                      />
                    </svg>
                    {{
                      detailSupplier.kompetensiPjo
                        ? detailSupplier.kompetensiPjo
                        : "-"
                    }}
                  </div>
                  <div class="d-flex align-items-center pt-2 fs-8">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      style="margin-right: 0.3rem"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.9987 13.6668C3.3168 13.6668 0.332031 10.6821 0.332031 7.00016C0.332031 3.31826 3.3168 0.333496 6.9987 0.333496C10.6806 0.333496 13.6654 3.31826 13.6654 7.00016C13.6613 10.6804 10.6789 13.6628 6.9987 13.6668ZM6.9987 1.66683C4.05318 1.66683 1.66536 4.05464 1.66536 7.00016C1.66536 9.94568 4.05318 12.3335 6.9987 12.3335C9.94422 12.3335 12.332 9.94568 12.332 7.00016C12.3287 4.05601 9.94285 1.67014 6.9987 1.66683ZM10.332 7.66683H6.33203V3.66683H7.66536V6.3335H10.332V7.66683Z"
                        fill="#B51A1A"
                      />
                    </svg>
                    Berlaku hingga
                    {{
                      detailSupplier.tanggalBerakhir
                        ? moment(detailSupplier.tanggalBerakhir)
                            .local("id")
                            .format("dd MMMM yyyy")
                        : " - "
                    }}
                  </div>
                </div>
              </div>
              <div class="col-md-11 pt-1">
                <p class="mb-1 heading-content">Kode KBLI</p>
                <div class="table-responsive">
                  <table class="table table-striped">
                    <tbody class="tabel-tbody">
                      <tr v-for="kb in kblis" :key="kb.noKbli">
                        <td>{{ kb.kode }}</td>
                        <td style="width: 67%">{{ kb.deskripsi }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="row pt-4">
                  <div class="col-md-4">
                    <p class="mb-1 heading-content">BIDANG</p>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <tbody class="tabel-tbody">
                          <tr v-for="bd in bidang" :key="bd.no">
                            <td style="width: 5%">{{ bd.no }}</td>
                            <td>{{ bd.bidang }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <p class="mb-1 heading-content">SUB BIDANG</p>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <tbody class="tabel-tbody">
                          <tr v-for="sbd in subBidang" :key="sbd.no">
                            <td style="width: 5%">{{ sbd.no }}</td>
                            <td>{{ sbd.subbidang }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-end"
                  style="margin-top: 1.5rem"
                >
                  <button
                    @click="clickSimpan"
                    type="submit"
                    class="btn btn-sm bg-danger w-25 text-white"
                  >
                    Simpan
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>

<script>
// import SidebarComponent from "@/components/SideBar.vue";
import GlobalDataMixin from "../../GlobalDataMixin";

import axios from "axios";
import Swal from "sweetalert2";

import {
  API_BASE_URL,
  CMS_GET_DETAIL_SUPPLIER,
  CMS_SET_SUPPLIER,
  CMS_VIEW_DOCUMENT,
  CMS_VIEW_IMAGE,
} from "../../constants.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const url_get_kontraktor = API_BASE_URL + CMS_GET_DETAIL_SUPPLIER;
const url_simpan = API_BASE_URL + CMS_SET_SUPPLIER;
const url_view_document = API_BASE_URL + CMS_VIEW_DOCUMENT;

export default {
  mixins: [GlobalDataMixin],
  name: "DetailAddKontraktorPage",
  components: { DefaultLayout },
  data() {
    return {
      isLoading: false,
      detailSupplier: "",
      kontraktorId: null,
      kblis: "",
      bidang: [],
      subBidang: [],
      url_icon: "",
    };
  },
  mounted() {
    this.fetchData(this.$route.params.id);
  },
  methods: {
    preventSubmit() {
      console.log("prevent submit");
    },
    fetchData(id) {
      axios
        .get(url_get_kontraktor + id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("getSelectedKontraktorById => ", response);
          this.detailSupplier = response.data.data;
          this.kblis = response.data.kbli;
          this.url_icon =
            API_BASE_URL + CMS_VIEW_IMAGE + this.detailSupplier.image;

          // Mengelompokkan subbidang berdasarkan bidang
          let bidangs = JSON.parse(response.data.data.bidangUsahaGems);
          if (bidangs) {
            const groupedData = bidangs.reduce((acc, curr) => {
              if (!acc[curr.NMBIDANG]) {
                acc[curr.NMBIDANG] = [];
              }
              acc[curr.NMBIDANG].push(curr.SUBBIDANG);
              return acc;
            }, {});

            // Membuat format 1.1 disubbidang
            let bidangCounter = 1;
            for (const [bidang, subbidangArray] of Object.entries(
              groupedData
            )) {
              this.bidang.push({
                no: `${bidangCounter}.`,
                bidang: bidang,
              });
              subbidangArray.forEach((subbidang, index) => {
                this.subBidang.push({
                  no: `${bidangCounter}.${index + 1}`,
                  subbidang: subbidang,
                });
              });
              bidangCounter++;
            }
          }
        })
        .catch(() => this.$router.back());
    },
    clickSimpan() {
      Swal.fire({
        title: "Simpan Kontraktor",
        text: "Apakah anda yakin akan menyimpan data kontraktor ini ?",
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          this.simpanKontraktor();
        }
      });
    },
    simpanKontraktor() {
      let bodyJsonKbli = [];
      this.kblis.forEach((item) => {
        bodyJsonKbli.push({
          id: item.id,
          kode: item.kode,
          deskripsi: item.deskripsi,
        });
      });
      let bodyJson = {
        id: this.detailSupplier.id,
        isupplierCode: this.detailSupplier.isupplierCode,
        aribaCode: this.detailSupplier.aribaCode,
        gemsCode: this.detailSupplier.gemsCode,
        namaKontraktor: this.detailSupplier.namaKontraktor,
        badanUsaha: this.detailSupplier.badanUsaha,
        alamat: this.detailSupplier.alamat,
        negara: this.detailSupplier.negara,
        provinsi: this.detailSupplier.provinsi,
        kotaKabupaten: this.detailSupplier.kotaKabupaten,
        nib: this.detailSupplier.noNib != null ? 1 : 0,
        noNib: this.detailSupplier.noNib,
        iujp: this.detailSupplier.noIujp != null ? 1 : 0,
        noIujp: this.detailSupplier.noIujp,
        sbujk: this.detailSupplier.noSbujk != null ? 1 : 0,
        noSbujk: this.detailSupplier.noSbujk,
        iujptl: this.detailSupplier.noIujptl != null ? 1 : 0,
        noIujptl: this.detailSupplier.noIujptl,
        inuBbm: this.detailSupplier.noInuBbm != null ? 1 : 0,
        noInuBbm: this.detailSupplier.noInuBbm,
        siupal: this.detailSupplier.noSiupal != null ? 1 : 0,
        noSiupal: this.detailSupplier.noSiupal,
        tglExpIujp: this.detailSupplier.tglExpIujp,
        nilai: this.detailSupplier.nilai,
        keterangan: this.detailSupplier.keterangan,
        tingkatResiko: this.detailSupplier.tingkatResiko,
        tanggalBerakhir: this.detailSupplier.tanggalBerakhir,
        picName: this.detailSupplier.picName,
        picPosition: this.detailSupplier.picPosition,
        picEmail: this.detailSupplier.picEmail,
        picPhoneCode: this.detailSupplier.picPhoneCode,
        picPhone: this.detailSupplier.picPhone,
        bidangUsahaGems: this.detailSupplier.bidangUsahaGems,
        namaPjo: this.detailSupplier.namaPjo,
        kompetensiPjo: this.detailSupplier.kompetensiPjo,
        nilaiPredikat: this.detailSupplier.nilaiPredikat,
        predikat: this.detailSupplier.predikat,
        inisial: this.detailSupplier.inisial,
        parentKontraktor: this.detailSupplier.parentKontraktor,
        noPengesahanPjo: this.detailSupplier.noPengesahanPjo,
        tglSuratPengesahan: this.detailSupplier.tglSuratPengesahan,
        kualifikasiUsaha: this.detailSupplier.kualifikasiUsaha,
        isDeleted: false,
        kbli: bodyJsonKbli,
      };

      axios
        .post(url_simpan, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("simpanKontraktor => ", response);
          this.kontraktorId = response.data.kontraktorID;
          this.alertSukses();
        })
        .catch((error) => {
          console.log("error simpanKontraktor => ", error);
          this.isLoading = false;
        });
    },
    alertSukses() {
      Swal.fire({
        title: "Penambahan Kontraktor Berhasil",
        text: "Data supplier telah berhasil ditambahkan ke daftar kontraktor!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        this.$router.back();
      });
    },
    viewFile(fileName) {
      window.open(url_view_document + fileName, "_blank");
    },
  },
};
</script>
